// lib/analytics/logSearch.ts
// Browser-side beacon for the SETTLED search (the sibling of track.ts for the
// "search" funnel stage). The widget shows instant results as-you-type without
// logging; once the query settles (idle 800ms) — or the page is about to unload
// on a product click — it beacons the FINAL query here.
//
//   • navigator.sendBeacon SURVIVES page unload, so a settled search flushed on a
//     product-click navigation is still delivered (same reason track.ts uses it).
//   • text/plain Blob = CORS-safelisted → no preflight.
//   • The URL MUST carry ?client= (server resolves the tenant only from it).
//   • Reuses the searchId the /api/search response returned, so clicks that carry
//     that id join to this row. Never throws, never blocks.

export interface LogSearchPayload {
  /** The searchId from the /api/search response for the shown results. */
  searchId?: string | null;
  query: string;
  normalizedQuery?: string | null;
  resultsCount?: number | null;
  filtersUsed?: string[];
  visitorId?: string | null;
  sessionId?: string | null;
  externalCustomerId?: string | null;
}

export function logSettledSearch(
  apiOrigin: string | undefined,
  clientId: string,
  payload: LogSearchPayload,
): void {
  try {
    if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return;
    if (!clientId || !payload.query) return;
    const url = `${apiOrigin ?? ''}/api/analytics/log-search?client=${encodeURIComponent(clientId)}`;
    const blob = new Blob([JSON.stringify(payload)], { type: 'text/plain' });
    navigator.sendBeacon(url, blob);
  } catch {
    // Swallow everything — a blocked/unavailable beacon must never surface.
  }
}
